/* eslint-disable max-len */
import React from 'react';
import { Switch } from 'react-router-dom';

import ParametersFamiliesFormPage from '../components/parameters/NewCategoryFamilyForm';
import ParametersPlacesFormPage from '../components/parameters/NewPlacesForm';
import ROUTES from '../data/routes';
import AccessLoginReport from '../pages/accessLoginReport/index';
import PurchaseReportPage from '../pages/purchaseReport/index';
import AccessProfilePage from '../pages/AccessProfile';
import AccessProfileConfigPage from '../pages/AccessProfileConfig';
import AccessProfileFormPage from '../pages/AccessProfileForm';
import AdminUsersPage from '../pages/AdminUsers';
import AdmMenuPage from '../pages/AdmMenu';
import AdmMenuFormPage from '../pages/AdmMenuForm';
import AllUsersPage from '../pages/AllUsers';
import BannersPage from '../pages/Banners';
import BannersForm from '../pages/BannersForm';
import CategoryPage from '../pages/Category';
import ClientsPage from '../pages/Clients';
import ContactoOfProjectsForIntegratorsPage from '../pages/contactoOfProjectsForIntegrators';
import CoursesAndTrainingPage from '../pages/coursesAndTraining';
import DiscountCouponPage from '../pages/discountCoupon';
import DiscountCouponHistoryPage from '../pages/discountCouponHistory';
import HomeGate from '../pages/HomeGate';
import FeaturedManufacturerPage from '../pages/FeaturedManufacturer';
import FeaturedManufacturerForm from '../pages/FeaturedManufacturerForm';
import FormPage from '../pages/Form';
import LayoutPage from '../pages/Layout';
import LoginPage from '../pages/Login';
import NotificationEmailPage from '../pages/notificationEmail';
import ManufacturersPage from '../pages/Manufacturers';
import ManufacturersForm from '../pages/ManufacturersForm';
import NotFoundPage from '../pages/NotFound';
import Notify from '../pages/Notify';
import NotifyHistoryPage from '../pages/notifyHistory';
import OrdersPage from '../pages/Orders';
import OrdersCheckbuyPage from '../pages/OrdersCheckbuy';
import OrdersPunchoutPage from '../pages/OrdersPunchout';
import Parameters from '../pages/Parameters';
import ProductFeedbackReason from '../pages/productFeedbackReason';
import ProductsPage from '../pages/Products';
import ProjectsDirectoryPage from '../pages/ProjectsDirectory';
import PromotionPage from '../pages/Promotion';
import PunchOutRulePage from '../pages/PunchOutRules';
import PurchaseFeedback from '../pages/PurchaseFeedback';
import RecommendedPage from '../pages/Recommended';
import RegisterMonitorPage from '../pages/RegisterMonitor';
import RegisterMonitorDetails from '../pages/RegisterMonitorDetails';
import RegisterMonitorEdit from '../pages/RegisterMonitorEdit';
import RegisterSolicitaionPage from '../pages/RegisterSolicitation';
import TechnicalMaterialPage from '../pages/technicalMaterial';
import UploadAdministrators from '../pages/UploadAdministrators';
import UploadBannersPage from '../pages/UploadBanners';
import UploadCategoriesPage from '../pages/UploadCategories';
import UploadClientsPage from '../pages/UploadClients';
import UploadClientUsersPage from '../pages/UploadClientUsers';
import UploadCoursesAndTrainingPage from '../pages/UploadCoursesAndTraining';
import UploadDiscountCouponPage from '../pages/UploadDiscountCoupon';
import UploadFeaturedManufactures from '../pages/UploadFeaturedManufactures';
import UploadManufacturersPage from '../pages/UploadManufacturers';
import UploadProductsPage from '../pages/UploadProducts';
import UploadProjectsDirectoryPage from '../pages/UploadProjectsDirectory';
import UploadPromotions from '../pages/UploadPromotions';
import UploadRecommendeds from '../pages/UploadRecommendeds';
import UploadTechnicalMaterialPage from '../pages/UploadTechnicalMaterial';
import UploadUsersPage from '../pages/UploadUsers';
import UsersPage from '../pages/Users';
import PrivateRoute from './PrivateRoute';
import PublicRoute from './PublicRoute';
import TypeSolutionPage from '../pages/TypeSolution';
import CableCategoryPage from '../pages/CableCategory';
import TypeCoatingPage from '../pages/TypeCoating';
import ProductTelecomPage from '../pages/ProductTelecom';
import SupplierTelecomPage from '../pages/supplierTelecom';
import ApplicationTypePage from '../pages/applicationType';
import VoltagePage from '../pages/voltage';
import PowerRangePage from '../pages/powerRange';
import PowerPage from '../pages/power';
import AutomationProductsPage from '../pages/automationProducts';
import UploadAutomationProductsPage from '../pages/uploadAutomationProducts';

// import HomePage from '../pages/Home';
import PunchOutN2RulePage from '../pages/PunchOutN2Rules';
import Abandoned from '../pages/Abandoned';
import LeadTimeForm from '../components/parameters/LeadTimeForm';
import OverdueClients from '../pages/OverdueClients';
import BranchManagerPage from '../pages/BranchManager';
import Packs from '../pages/Packs';
import UploadPacksPage from '../pages/UploadPacks';
import AnalyticsPage from '../pages/analytics/index';

const Content = () => (
  <Switch>
    {/* <PrivateRoute path={ROUTES.HOME} component={HomePage} exact /> */}
    <PrivateRoute path={ROUTES.HOME} component={HomeGate} exact />
    <PrivateRoute path={ROUTES.USERS} component={UsersPage} exact />
    <PrivateRoute path={ROUTES.CLIENTS} component={ClientsPage} exact code="CLIENTS" />
    <PrivateRoute path={ROUTES.ACCESS_PROFILE} component={AccessProfilePage} exact code="ACCESS_PROFILE" />
    <PrivateRoute path={ROUTES.ACCESS_PROFILE_FORM} component={AccessProfileFormPage} exact />
    <PrivateRoute path={ROUTES.ACCESS_PROFILE_CONFIG} component={AccessProfileConfigPage} exact />
    <PrivateRoute path={ROUTES.ALL_USERS} component={AllUsersPage} exact code="ALL_USERS" />
    <PrivateRoute path={ROUTES.ORDERS} component={OrdersPage} exact code="ORDERS" />
    <PrivateRoute path={ROUTES.ORDERS_CHECKBUY} component={OrdersCheckbuyPage} exact code="ORDERS_CHECKBUY" />
    <PrivateRoute path={ROUTES.ORDERS_PUNCHOUT} component={OrdersPunchoutPage} exact code="ORDERS_PUNCHOUT" />
    <PrivateRoute path={ROUTES.PRODUCTS} component={ProductsPage} exact code="PRODUCTS" />
    <PrivateRoute path={ROUTES.CATEGORY} component={CategoryPage} exact code="CATEGORY" />
    <PrivateRoute path={ROUTES.PROMOTION} component={PromotionPage} exact code="PROMOTION" />
    <PrivateRoute path={ROUTES.DISCOUNT_COUPON} component={DiscountCouponPage} exact code="DISCOUNT_COUPON" />
    <PrivateRoute path={ROUTES.UPLOAD_DISCOUNT_COUPON} component={UploadDiscountCouponPage} exact />
    <PrivateRoute path={ROUTES.DISCOUNT_COUPON_HISTORY} component={DiscountCouponHistoryPage} exact />
    <PrivateRoute path={ROUTES.UPLOAD_PRODUCTS} component={UploadProductsPage} exact />
    <PrivateRoute path={ROUTES.UPLOAD_USERS} component={UploadUsersPage} exact />
    <PrivateRoute path={ROUTES.UPLOAD_CLIENTS} component={UploadClientsPage} exact />
    <PrivateRoute path={ROUTES.UPLOAD_CLIENT_USERS} component={UploadClientUsersPage} exact />
    <PrivateRoute path={ROUTES.UPLOAD_CATEGORIES} component={UploadCategoriesPage} exact />
    <PrivateRoute path={ROUTES.UPLOAD_BANNERS} component={UploadBannersPage} exact />
    <PrivateRoute path={ROUTES.UPLOAD_MANUFACTURERS} component={UploadManufacturersPage} exact />
    <PrivateRoute path={ROUTES.UPLOAD_FEATURED_MANUFACTURE} component={UploadFeaturedManufactures} exact />
    <PrivateRoute path={ROUTES.UPLOAD_PROMOTIONS} component={UploadPromotions} exact />
    <PrivateRoute path={ROUTES.UPLOAD_ADMINISTRATORS} component={UploadAdministrators} exact />
    <PrivateRoute path={ROUTES.REGISTER_SOLICITATION} component={RegisterSolicitaionPage} exact code="REGISTER_SOLICITATION" />
    <PrivateRoute path={ROUTES.FORM} component={FormPage} exact />
    <PrivateRoute path={ROUTES.BANNERS} component={BannersPage} exact code="BANNERS" />
    <PrivateRoute path={ROUTES.MANUFACTURERS} component={ManufacturersPage} exact code="MANUFACTURERS" />
    <PrivateRoute path={ROUTES.FEATURED_MANUFACTURE} component={FeaturedManufacturerPage} exact code="FEATURED_MANUFACTURE" />
    <PrivateRoute path={ROUTES.LAYOUT} component={LayoutPage} exact code="LAYOUT" />
    <PrivateRoute path={ROUTES.FEATURED_MANUFACTURE_FORM} component={FeaturedManufacturerForm} exact code="FEATURED_MANUFACTURE_FORM" />
    <PrivateRoute path={ROUTES.BANNERS_FORM} component={BannersForm} exact />
    <PrivateRoute path={ROUTES.MANUFACTURERS_FORM} component={ManufacturersForm} exact />
    <PrivateRoute path={ROUTES.PARAMETERS} component={Parameters} exact code="PARAMETERS" />
    <PrivateRoute path={ROUTES.PARAMETERS_PLACES_FORM} component={ParametersPlacesFormPage} exact />
    <PrivateRoute path={ROUTES.PARAMETERS_LEAD_TIME_FORM} component={LeadTimeForm} exact />
    <PrivateRoute path={ROUTES.PARAMETERS_FAMILIES_FORM} component={ParametersFamiliesFormPage} exact />
    <PrivateRoute path={ROUTES.REGISTER_MONITOR} component={RegisterMonitorPage} exact code="REGISTER_MONITOR" />
    <PrivateRoute path={ROUTES.REGISTER_MONITOR_DETAILS} component={RegisterMonitorDetails} exact />
    <PrivateRoute path={ROUTES.REGISTER_MONITOR_EDIT} component={RegisterMonitorEdit} exact />
    <PrivateRoute path={ROUTES.ADMIN_USERS} component={AdminUsersPage} exact code="ADMIN_USERS" />
    <PrivateRoute path={ROUTES.ADM_MENU_1.split('?')[0]} component={AdmMenuPage} exact code="ADM_MENU_1" />
    <PrivateRoute path={ROUTES.ADM_MENU_2.split('?')[0]} component={AdmMenuPage} exact code="ADM_MENU_2" />
    <PrivateRoute path={ROUTES.ADM_MENU_3.split('?')[0]} component={AdmMenuPage} exact code="ADM_MENU_3" />
    <PrivateRoute path={ROUTES.ADM_MENU_4.split('?')[0]} component={AdmMenuPage} exact code="ADM_MENU_4" />
    <PrivateRoute path={ROUTES.ADM_MENU_5.split('?')[0]} component={AdmMenuPage} exact code="ADM_MENU_5" />
    <PrivateRoute path={ROUTES.ADM_MENU_FORM} component={AdmMenuFormPage} exact />
    <PrivateRoute path={ROUTES.PUNCHOUT_RULE} component={PunchOutRulePage} exact code="PUNCHOUT_RULE" />
    <PrivateRoute path={ROUTES.PUNCHOUT_N2_RULE} component={PunchOutN2RulePage} exact code="PUNCHOUT_N2_RULE" />
    <PrivateRoute path={ROUTES.RECOMMENDED} component={RecommendedPage} exact code="RECOMMENDED" />
    <PrivateRoute path={ROUTES.UPLOAD_RECOMMENDEDS} component={UploadRecommendeds} exact />
    <PrivateRoute path={ROUTES.ACCESS_LOGIN_REPORT} component={AccessLoginReport} exact code="ACCESS_LOGIN_REPORT" />
    <PrivateRoute path={ROUTES.PURCHASE_REPORT} component={PurchaseReportPage} exact code="PURCHASE_REPORT" />
    <PrivateRoute path={ROUTES.ANALYTICS} component={AnalyticsPage} exact code="ANALYTICS" />
    <PrivateRoute path={ROUTES.PRODUCT_FEEDBACK_REASON} component={ProductFeedbackReason} exact code="PRODUCT_FEEDBACK_REASON" />
    <PrivateRoute path={ROUTES.PURCHASE_FEEDBACK} component={PurchaseFeedback} exact code="PURCHASE_FEEDBACK" />
    <PrivateRoute path={ROUTES.PROJECTS_DIRECTORY} component={ProjectsDirectoryPage} exact code="PROJECTS_DIRECTORY" />
    <PrivateRoute path={ROUTES.UPLOAD_PROJECTS_DIRECTORY} component={UploadProjectsDirectoryPage} exact />
    <PrivateRoute path={ROUTES.TECHNICAL_MATERIAL} component={TechnicalMaterialPage} exact code="TECHNICAL_MATERIAL" />
    <PrivateRoute path={ROUTES.UPLOAD_TECHNICAL_MATERIAL} component={UploadTechnicalMaterialPage} exact />
    <PrivateRoute path={ROUTES.COURSES_AND_TRAINING} component={CoursesAndTrainingPage} exact code="COURSES_AND_TRAINING" />
    <PrivateRoute path={ROUTES.NOTIFICATION_EMAIL} component={NotificationEmailPage} exact code="NOTIFICATION_EMAIL" />
    <PrivateRoute
      path={ROUTES.CONTACTO_OF_PROJECTS_FOR_INTEGRATORS}
      component={ContactoOfProjectsForIntegratorsPage}
      code="CONTACTO_OF_PROJECTS_FOR_INTEGRATORS"
      exact
    />
    <PrivateRoute path={ROUTES.UPLOAD_COURSES_AND_TRAINING} component={UploadCoursesAndTrainingPage} exact />
    <PrivateRoute path={ROUTES.NOTIFY} component={Notify} exact />
    <PrivateRoute path={ROUTES.NOTIFY_HISTORY} component={NotifyHistoryPage} exact />
    <PrivateRoute path={ROUTES.TYPE_SOLUTION} component={TypeSolutionPage} exact />
    <PrivateRoute path={ROUTES.CABLE_CATEGORY} component={CableCategoryPage} exact />
    <PrivateRoute path={ROUTES.TYPE_COATING} component={TypeCoatingPage} exact />
    <PrivateRoute path={ROUTES.PRODUCT_TELECOM} component={ProductTelecomPage} exact />
    <PrivateRoute path={ROUTES.SUPPLIER_TELECOM} component={SupplierTelecomPage} exact />
    <PrivateRoute
      path={ROUTES.SUPPLIER_AUTOMATION}
      code="SUPPLIER_AUTOMATION"
      component={SupplierTelecomPage}
      exact
      actions={{
        list: 'getListSupplierAutomation',
        update: 'updateSupplierAutomation',
        create: 'createSupplierAutomation',
      }}
    />
    <PrivateRoute path={ROUTES.APPLICATION_TYPE} code="APPLICATION_TYPE" component={ApplicationTypePage} exact />
    <PrivateRoute path={ROUTES.VOLTAGE} code="VOLTAGE" component={VoltagePage} exact />
    <PrivateRoute path={ROUTES.POWER_RANGE} code="POWER_RANGE" component={PowerRangePage} exact />
    <PrivateRoute path={ROUTES.POWER} component={PowerPage} exact />
    <PrivateRoute path={ROUTES.AUTOMATION_PRODUCTS} code="AUTOMATION_PRODUCTS" component={AutomationProductsPage} exact />
    <PrivateRoute path={ROUTES.UPLOAD_AUTOMATION_PRODUCTS} component={UploadAutomationProductsPage} exact />
    <PublicRoute path={ROUTES.LOGIN} component={LoginPage} exact />
    <PrivateRoute path={ROUTES.ABANDONED} component={Abandoned} exact code="ABANDONED" />
    <PrivateRoute path={ROUTES.OVERDUE_CLIENTS} component={OverdueClients} exact code="OVERDUE_CLIENTS" />
    <PrivateRoute path={ROUTES.BRANCH_MANAGER} component={BranchManagerPage} exact code="BRANCH_MANAGER" />
    <PrivateRoute path={ROUTES.OVERDUE_CLIENTS} component={OverdueClients} exact code="OVERDUE_CLIENTS" />
    <PrivateRoute path={ROUTES.PACKS} component={Packs} exact code="PACKS" />
    <PrivateRoute path={ROUTES.UPLOAD_PACKS} component={UploadPacksPage} exact />
    <PublicRoute component={NotFoundPage} />
  </Switch>
);

export default Content;
